/**
 * 通知管理器组件
 * 从 MainPage.tsx 提取，统一管理所有 Snackbar 通知
 */

import React from 'react';
import {
  Snackbar,
  Alert,
  Box
} from '@mui/material';

interface NotificationManagerProps {
  // 主通知
  snackbarOpen: boolean;
  setSnackbarOpen: (open: boolean) => void;
  snackbarMessage: string;
  snackbarSeverity: 'error' | 'warning' | 'info' | 'success';
  
  // 自动保存通知
  autoSaveSnackbarOpen: boolean;
  setAutoSaveSnackbarOpen: (open: boolean) => void;
  autoSaveMessage: string;
  
  // 错误通知
  videoError: string | null;
  setVideoError: (error: string | null) => void;
}

const NotificationManager: React.FC<NotificationManagerProps> = ({
  snackbarOpen,
  setSnackbarOpen,
  snackbarMessage,
  snackbarSeverity,
  autoSaveSnackbarOpen,
  setAutoSaveSnackbarOpen,
  autoSaveMessage,
  videoError,
  setVideoError
}) => {
  return (
    <>
      {/* 主通知 Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        sx={{
          zIndex: 9999,
          bottom: { xs: 70, sm: 70 }
        }}
        ContentProps={{
          sx: {
            minWidth: 0,
            width: 'fit-content',
            maxWidth: 320,
            p: 1,
            borderRadius: 2,
            fontSize: '0.85rem',
            boxShadow: 3,
            alignItems: 'center',
          }
        }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%', p: 0.5, fontSize: '0.95em', alignItems: 'center' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* 自動保存提示 Snackbar */}
      <Snackbar
        open={autoSaveSnackbarOpen}
        autoHideDuration={2000}
        onClose={() => setAutoSaveSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ zIndex: 9999 }}
      >
        <Alert
          onClose={() => setAutoSaveSnackbarOpen(false)}
          severity="success"
          sx={{ 
            width: '100%', 
            p: 1, 
            fontSize: '0.9em', 
            alignItems: 'center',
            backgroundColor: '#4caf50',
            color: 'white'
          }}
        >
          {autoSaveMessage}
        </Alert>
      </Snackbar>

      {/* 顯示影片載入錯誤 */}
      {videoError && (
        <Snackbar
          open={true}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ zIndex: 9999 }}
        >
          <Box>
            <Alert
              severity="error"
              sx={{ width: '100%', p: 1, fontSize: '0.95em' }}
              onClose={() => setVideoError(null)}
            >
              {videoError}
            </Alert>
          </Box>
        </Snackbar>
      )}
    </>
  );
};

export default NotificationManager;

